import { useAppTheme } from '@shared-ui/theme'
import Svg, { Path } from 'react-native-svg'

type Props = {
  size?: number
  color?: string
}

export function AppIconKycVerifyOutline({ size = 20, color }: Props) {
  const theme = useAppTheme()
  const fill = color ?? theme.COLOR_TEXT_PRIMARY

  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <Path
        fill={fill}
        d="M6.09789 8.58586C6.09789 9.14226 5.87719 9.67603 5.48383 10.0695L3.55258 11.9995L5.48383 13.9308C5.87729 14.3242 6.09779 14.8582 6.09789 15.4144V17.9023H8.58578C9.07256 17.9023 9.54239 18.0719 9.91586 18.378L10.0694 18.5175L11.9995 20.4476L13.9307 18.5175L14.0854 18.378C14.4587 18.0721 14.9277 17.9024 15.4143 17.9023H17.9022V15.4144C17.9023 14.8581 18.1241 14.3241 18.5174 13.9308L20.4475 11.9995L18.5174 10.0695C18.1242 9.67612 17.9022 9.14241 17.9022 8.58586V6.09797H15.4143C14.858 6.09786 14.3241 5.87736 13.9307 5.48391L11.9995 3.55266L10.0694 5.48391C9.67592 5.87732 9.14211 6.09797 8.58578 6.09797H6.09789V8.58586ZM20.0983 8.54485L22.0694 10.5171C22.8889 11.3364 22.8889 12.665 22.0694 13.4843L20.0983 15.4554V18.0007C20.0982 19.1593 19.1592 20.0983 18.0006 20.0984H15.4565L13.4842 22.0695C12.6648 22.8886 11.3364 22.8886 10.517 22.0695L8.54477 20.0984H6.00063C4.84199 20.0984 3.90305 19.1594 3.90297 18.0007V15.4554L1.93071 13.4843C1.11159 12.6651 1.11169 11.3364 1.93071 10.5171L3.90297 8.54485V6.00071C3.90297 4.84203 4.84192 3.90305 6.00063 3.90305H8.54477L10.517 1.93079L10.6764 1.78665C11.4455 1.15971 12.5558 1.15961 13.3248 1.78665L13.4842 1.93079L15.4565 3.90305H18.0006C19.1593 3.90316 20.0983 4.8421 20.0983 6.00071V8.54485Z"
      />
      <Path
        fill={fill}
        d="M13.6014 9.12116C13.9492 8.62437 14.6339 8.50271 15.1307 8.85046C15.6274 9.19816 15.7477 9.88301 15.4002 10.3798L11.8998 15.3801C11.721 15.6355 11.4418 15.8032 11.1323 15.8407C10.823 15.878 10.5125 15.7821 10.278 15.577L8.27758 13.8262C7.82147 13.4269 7.77521 12.7333 8.17446 12.277C8.57379 11.821 9.26741 11.7748 9.72367 12.1739L10.8018 13.1173L13.6014 9.12116Z"
      />
    </Svg>
  )
}
